import React from 'react';

// Newsletter component that links to VR Mail Chimp form
class NewsletterSignUp extends React.PureComponent {
  constructor(props) {
    super(props);

    this.updateInputValue = this.updateInputValue.bind(this);

    this.state = {
      email: ""
    };
  }

  updateInputValue(e){
   this.setState({
     email: e.target.value
   });
  }

  render() {
    const { email} = this.state;

    return (
      <div className="newsletter-signup w-100 flex flex-column items-center">
        <div className="mh2 mw-696">
          <h4 className="newsletter-signup__header dark h-4 h-3--l tc ttu">
            Let us help you keep up with the latest downtown events, news and
            more!
          </h4>
          <div className="relative">
            <form
              data-netlify-recaptcha
              data-netlify-honeypot="bot-field"
              method="POST"
              action="/"
              target="_blank"
              id="newsletter-form"
              name="newsletter"
            >
              <input type="hidden" name="form-name" value="newsletter" />
              <span className="dn">
                <input name="bot-field" />
              </span>
              <div className="newsletter-signup__wrapper flex-l w-100">
                {/* <div className="newsletter-signup__border--1 w-100">
                  <div className="newsletter-signup__border--2">
                    <input
                      className='form__input w-100 p'
                      name="email"
                      value={email}
                      onChange={this.updateInputValue}
                      placeholder="Enter Email Address"
                      aria-labelledby="Enter your Email"
                    />
                  </div>
                </div> */}

                <a
                  className="form__button bg-blue bg-ease-out b--none h-5 white w-100 ttu flex justify-center items-center"
                  target="_blank"
                  href={`https://mailchi.mp/venturerichmond/newsletter-signup-page?MERGE0=${email}`}
                >
                  Sign Up!
                </a>
              </div>
            </form>
          </div>
        </div>
        <div className="newsletter-signup__donate w-100 flex flex-column items-center bg-stone-light">
        <div className="mh2 mw-696">
          <h4 className="newsletter-signup__header grey1 h-5--l tc ttu">
            Help us build Richmond To its Full potential <a className="blue donate" href="/about-us/donate/">Donate Now</a>
          </h4>
        </div>
      </div>
      </div>
    );
  }
}

export default NewsletterSignUp;



// WEBPACK FOOTER //
// ./src/components/NewsletterSignUp.js